import { t } from '@lingui/macro'
import styled from 'styled-components'

import { H2 } from '@/@bothrs-ui/web/components/typography/Heading'
import { breakpoints } from '@/config/layout'
import { useSubjectName } from '@/modules/trust/hooks/useSubjectName'

export const IntramurosHeader = () => {
  const name = useSubjectName()

  return (
    <StContainer>
      <H2 noMargin>
        {t({
          id: 'intramuros.tasks.header.title',
          message: 'Taken van {name}',
          values: { name },
        })}
      </H2>
    </StContainer>
  )
}

const StContainer = styled.div`
  ${({ theme }) => `
    background-color: ${theme.Colors.Background.White};
    border-bottom: 1px solid ${theme.Components.Card.Border};

    @media ${breakpoints.s} {
      padding: ${theme.UI.SpacingPx.Space4} ${theme.UI.SpacingPx.Space6};
    }
    @media ${breakpoints.m} {
      padding: ${theme.UI.SpacingPx.Space4} ${theme.UI.SpacingPx.Space12};
    }
    @media ${breakpoints.l} {
      padding: ${theme.UI.SpacingPx.Space4} ${theme.UI.SpacingPx.Space20};
    }
  `}
`
